import PropTypes from 'prop-types';

import ProgressCollapse from './ProgressCollapse';
import ProgressExpand from './ProgressExpand';

const propTypes = {
  paths: PropTypes.array,
  active: PropTypes.bool,
  onToggleManage: PropTypes.func,
  profileIndex: PropTypes.number,
  isCollapse: PropTypes.bool,
  getLabel: PropTypes.func,
};

export default function ProgressContainer({ paths, onToggleManage, profileIndex, isCollapse, getLabel }) {
  if (!paths) return null
  const total = paths.reduce((current, item) => current + (parseInt(item.weigth, 10) || 0), 0)
  const toggleManageItem = idx => onToggleManage(profileIndex, idx)

  return <>
    {isCollapse ? <ProgressCollapse
      total={total}
      paths={paths}
      getLabel={getLabel}
      onToggleManage={toggleManageItem}
    /> : <ProgressExpand
      paths={paths}
      total={total}
      getLabel={getLabel}
      onToggleManage={toggleManageItem}
    />
    }
  </>
}

ProgressContainer.propTypes = propTypes
ProgressContainer.defaultProps = {}
